import { Link } from "react-router-dom";
import { ArrowUpRight, Activity } from "lucide-react";
import { NAV_LINKS, SITE } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-michma-ink text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2.5 mb-6">
              
              <span className="font-heading font-extrabold text-2xl">
                <img src="/logoMichmaLight.png" alt="Michma" className="h-20 w-auto" />
              </span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight leading-[1.05] max-w-xl">
              Public Health Infinitism.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 mt-8 bg-white text-michma-ink rounded-full px-7 py-4 font-semibold hover:bg-michma-tint hover:-translate-y-0.5 transition-[transform,background-color] duration-300"
            >
              Get involved <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mb-5">
              Explore
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.name}>
                  {link.external ? (
                    <a
                      href={link.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-white/70 hover:text-white transition-colors"
                    >
                      {link.name} <ArrowUpRight className="w-3.5 h-3.5" />
                    </a>
                  ) : (
                    <Link
                      to={link.path}
                      className="text-white/70 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  )}
                  {link.children && (
                    <ul className="mt-2 ml-3 space-y-2 border-l border-white/10 pl-4">
                      {link.children.map((child) => (
                        <li key={child.name}>
                          <Link
                            to={child.path}
                            className="text-white/50 hover:text-white transition-colors text-sm"
                          >
                            {child.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mb-5">
              Reach us
            </p>
            <a
              href={`mailto:${SITE.email}`}
              className="block text-white/70 hover:text-white transition-colors mb-2"
            >
              {SITE.email}
            </a>
            <a
              href={`tel:${SITE.phone.replace(/[^+\d]/g, "")}`}
              className="block text-white/70 hover:text-white transition-colors mb-6"
            >
              {SITE.phone}
            </a>
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {SITE.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            © {new Date().getFullYear()} {SITE.name} Foundation. All rights reserved.
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">
            {SITE.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
